import type { Nullable } from '@accesso/cc-std-lib';

import { isNonEmptyString } from '@accesso/cc-std-lib';

export const seoTitle = (...args: Nullable<string | undefined>[]): string => args.filter(isNonEmptyString).join(' | ');
